import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonGroup } from "@mui/material";
export const UiButtonGroup = (props) => (_jsx(ButtonGroup, Object.assign({}, props)));
//# sourceMappingURL=ui_button_group.js.map